<div class="wrapper cv-dialog-form">
	<div class="row">
		<div class="col-sm-12">
			<cv-dropdown
				[required]="true"
				[label]="'Origin'"
				[placeholder]="'Select an origin'"
				[options]="originsList"
				[selectedValue]="originSelected"
				[optionText]="'name'"
				(valuesChange)="onOriginSelected($event)"
				[clearSelection]="false"
			>
			</cv-dropdown>
		</div>
	</div>
	<div class="row">
		<div class="col-sm-12">
			<label for="ci-product-organization" class="ci-product-label">ORGANIZATION</label>
			<p-dropdown
				[id]="'ci-product-organization'"
				[title]="'Organization'"
				[placeholder]="'Select an organization'"
				[options]="organizations"
				[filter]="true"
				[optionLabel]="'name'"
				[styleClass]="'ci-product-dropdown'"
				class="ci-product-dropdown"
				[(ngModel)]="this.organizationSelected"
				[showClear]="true"
				(onFilter)="searchOrganizations($event)"
				(onChange)="onOrganizationSelected($event)"
			>
			</p-dropdown>
		</div>
	</div>
	<div class="row">
		<div class="col-sm-12 product-dropdown">
			<cv-multiselect-search
				[label]="'Product'"
				[placeholder]="'Select a product'"
				[options]="productListOptions"
				[values]="productSelected"
				[optionText]="'name'"
		        [optionValue]="'id'"
				[singleSelectMode]="true"
				[required]="true"
				(valuesChange)="onProductSelected($event)"
			>
			</cv-multiselect-search>
		</div>
	</div>
	<div class="row">
		<div class="col-sm-12">
			<cv-dropdown
				[required]="true"
				[label]="'Form Type'"
				[placeholder]="'Select a form type'"
				[options]="formTypesList"
				[optionText]="'name'"
				[selectedValue]="formTypeSelected"
				(valuesChange)="onFormTypeSelected($event)"
			>
			</cv-dropdown>
		</div>
	</div>
	<div class="product-check-container mt-2">
			<cv-switch
				[class]="'cv-switch-blue'"
				[checked]="ciJobTypeData.isHybridProduct"
				[size]="'sm'"
				(valueChange)="onSwitchChange($event, 'isHybridProduct')"
			>
			</cv-switch>
			<span class="info-test">Hybrid Product</span>
	</div>
	<div class="product-check-container mt-2">
			<cv-switch
				[class]="'cv-switch-blue'"
				[checked]="ciJobTypeData.isSubmitToUcdp"
				[size]="'sm'"
				(valueChange)="onSwitchChange($event, 'isSubmitToUcdp')"
			>
			</cv-switch>
			<span class="info-test">Submit this product to UCDP?</span>
	</div>
	<div class="product-check-container mt-2">
			<cv-switch
				[class]="'cv-switch-blue'"
				[checked]="ciJobTypeData.isSubmitToFhaPortal"
				[size]="'sm'"
				(valueChange)="onSwitchChange($event, 'isSubmitToFhaPortal')"
			>
			</cv-switch>
			<span class="info-test">Submit this product to the FHA portal?</span>
	</div>
</div>
